import { Box } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';
export interface SectionHeadersProps {
  title: string;
  subTitle: string;
  titleVariant?: WsTypoVariants;
}

export const SectionHeaders = ({
  title,
  subTitle,
  titleVariant = WsTypoVariants.BODY1,
}: SectionHeadersProps) => (
  <Box display="flex" flexDirection="column" rowGap={0.25}>
    <WsTypography variant={titleVariant} bold>
      {title}
    </WsTypography>
    <WsTypography variant={WsTypoVariants.BODY1}>{subTitle}</WsTypography>
  </Box>
);
